import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import SEO from "@/components/SEO";

export default function Blog() {
  const { pick, lang } = useLang();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/blog").then(r => setPosts(r.data)).finally(() => setLoading(false)); }, []);

  const dfmt = (iso) => iso ? new Date(iso).toLocaleDateString(lang === "en" ? "en-GB" : (lang === "nl" ? "nl-BE" : "fr-BE"), {day:"2-digit", month:"long", year:"numeric"}) : "";

  return (
    <div data-testid="blog-page" className="pt-32 pb-24 bg-[#0D0D0D] min-h-screen">
      <SEO title="Blog · Achat, vente et dépôt-vente de Porsche en Belgique" description="Le journal de KV International : guides d'achat Porsche, dépôt-vente, coaching pilotage simulateur, nouveaux arrivages et coulisses du spécialiste Porsche à Rhode-Saint-Genèse." />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C8A75A] mb-4">Journal</p>
        <h1 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-light text-white">Actualités</h1>
        <p className="text-white/60 text-lg mt-4 max-w-2xl">Nouveaux arrivages, sessions simulateur marquantes, événements et coulisses.</p>

        <div className="mt-16">
          {loading ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1,2,3].map(i => <div key={i} className="aspect-[4/3] bg-[#1E1E1E] rounded-md animate-pulse" />)}
            </div>
          ) : posts.length === 0 ? (
            <p className="text-white/40 py-32 text-center">Aucun article publié pour l'instant.</p>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((p) => (
                <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group bg-[#1E1E1E] border border-white/10 rounded-md overflow-hidden hover:border-[#C8A75A]/50 transition-colors">
                  {p.cover_image && (
                    <div className="aspect-[16/10] bg-black overflow-hidden">
                      <img src={p.cover_image} alt={`Article blog KV International — ${typeof p.title === "string" ? p.title : (p.title?.fr || "")}`} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    </div>
                  )}
                  <div className="p-6">
                    <p className="text-[10px] uppercase tracking-[0.25em] text-[#C8A75A] flex items-center gap-2 mb-3">
                      <Calendar className="w-3 h-3" /> {dfmt(p.published_at || p.created_at)}
                    </p>
                    <h3 className="font-display text-xl text-white leading-tight group-hover:text-[#C8A75A] transition-colors">{pick(p.title)}</h3>
                    {pick(p.excerpt) && <p className="text-white/60 text-sm mt-3 leading-relaxed line-clamp-3">{pick(p.excerpt)}</p>}
                    <div className="mt-4 pt-4 border-t border-white/5 text-[10px] uppercase tracking-widest text-white/40 group-hover:text-[#C8A75A] transition-colors inline-flex items-center gap-2">
                      Lire l'article <ArrowRight className="w-3 h-3" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
